/**
 * One CSV cell. Text a spreadsheet would read as a formula (= + - @, tab, CR first) gets a leading
 * apostrophe: names and memos come from outside — a shop order, an imported statement — and
 * `=HYPERLINK(…)` in one would run when the export is opened in Excel. Numbers are left as numbers.
 */
export function csvCell(c: string | number | null | undefined): string {
  if (typeof c === "number") return String(c);
  let s = String(c ?? "");
  if (/^[=+\-@\t\r]/.test(s) && !/^[+-]?\d+(\.\d+)?$/.test(s)) s = `'${s}`;
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
